import React from 'react';
import { useField } from 'react-final-form';

import { alertInfo } from '@dashboard/contexts/SnackbarManager/store';
import { useCurrentScenarioName } from '@wp-block-builder/editor/hooks';

import { useScenariosMutator } from '../../../hooks';

import ScenarioDialog from './ScenarioDialog';

type Props = {
  open: boolean;
  closeDialog: () => void;
};
export default function AddScenarioDialog({ open, closeDialog }: Props) {
  const [, setCurrentScenarioName] = useCurrentScenarioName();
  const scenarios = useScenariosMutator();
  const { input } = useField<string>('defaultPreviewVariables');

  if (!open) {
    return null;
  }
  return (
    <ScenarioDialog
      title="Add data scenario"
      description="Create a scenario to test different data payloads on your template."
      initialValue=""
      open={open}
      onSubmit={(name: string) => {
        scenarios.push({ name, variables: input.value });
        setCurrentScenarioName(`testScenarios[${scenarios.length}]`);
        alertInfo('Scenario added (with duplicated default data)');
      }}
      confirmButtonLabel="Add"
      handleClose={closeDialog}
    />
  );
}
